import React from 'react';
import { refactoredTimeAndDate } from '../../../../helpers/timeFormatter.helper';
import { DATE_FORMAT } from '../../../../constants/general';

interface IProps {
  timeDate: string;
}

const TimeAndDate = ({ timeDate }: IProps) => (
  <div id='transactionDetailsTnd' className='font-metricR text-[14px] text-bw06'>
    {refactoredTimeAndDate(timeDate, 'details', DATE_FORMAT.LETTERS)}
  </div>
);

export default TimeAndDate;
